export const BACKGROUND_IMAGE_URL =
  'https://d2yqx4uysedqc4.cloudfront.net/LoginBackgrounds/';
export const IMAGE_SUFFIX = '.jpg';
